import * as React from 'react'
import { Navigate, useParams } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import NotFound from 'modules/core/components/NotFound'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import documents from 'modules/documents/store/collections/documents'

const RedirectToDocumentUrl = () => {
  const { document_id: documentId, recipient_id: recipientId } = useParams()
  const [urlLoading, setUrlLoading] = React.useState(false)
  const [url, setUrl] = React.useState<string | null>(null)
  const { navigation } = useNavigation()

  const notifierDocumentUrl = navigation.files.notifierDocuments.fullPath({
    document_id: Number(documentId),
    recipient_id: Number(recipientId),
  })

  useEffect(() => {
    const initNotifierUrl = async () => {
      setUrlLoading(true)
      const response = await documents.notifierFileUrl(Number(documentId), Number(recipientId))
      setUrl(response)
      setUrlLoading(false)
    }

    initNotifierUrl()
  }, [recipientId, documentId, notifierDocumentUrl])

  const redirect = () => {
    const formattedUrl = url?.startsWith('/') ? url : `/${url}`
    const currentUrl = window.location.pathname.replace(`${notifierDocumentUrl}`, formattedUrl)

    return <Navigate to={currentUrl} />
  }

  if (urlLoading) {
    return (
      <Box padding="s40" width="full" alignItems="center">
        <Spinner />
      </Box>
    )
  }

  if (!url) {
    return <NotFound />
  }

  return redirect()
}

export default RedirectToDocumentUrl
